import Typography from 'bharat-ui/web/Typography';
import Card from 'bharat-ui/web/Card';
import Box from 'bharat-ui/web/Box';
import React from 'react';
import notFoundImg from '../../../assets/images/notfound.svg';
import { makeStyles } from 'bharat-ui/web/Styles';
import Button from 'bharat-ui/web/Button';
import { useSelectedLanguage } from 'Slices';

const useStyle = makeStyles(() => ({
	notFoundContainer: {
		padding: '40px',
	},
	notFoundImg: {
		height: '184px',
		objectFit: 'contain',
	},
	text: {
		fontSize: '16px',
		fontFamily: 'Heavy',
		color: '#1d1d1b',
		marginTop: '24px',
		textAlign: 'center',
	},
	retry: {
		width: '100%',
		marginTop: '30px',
	},
}));
interface Props {
	onRetry: () => void;
}
const NotFound: React.FC<Props> = ({ onRetry }) => {
	const classes = useStyle();
	const language = useSelectedLanguage();
	return (
		<div>
			<Card className={classes.notFoundContainer}>
				<Box display={'flex'} justifyContent={'center'} alignContent={'center'}>
					<img className={classes.notFoundImg} src={notFoundImg} />
				</Box>
				<Typography className={classes.text}>{language.SOMETHING_WENT_WRONG}</Typography>
			</Card>
			<Box display="flex">
				<Button className={classes.retry} onClick={onRetry}>
					<Typography>{language.TRY_AGAIN}</Typography>{' '}
				</Button>
			</Box>
		</div>
	);
};

export default NotFound;
